import classNames from 'classnames';
import { Children, ReactNode } from 'react';

import filterEmptyRecursive from '../../helpers/array/filterEmptyRecursive';
import ErrorList from '../../types/UI/ErrorList';
import Paragraph from '../Paragraph/Paragraph';
import Row from '../Row/Row';
import Stack from '../Stack/Stack';

import styles from './ErrorMessage.module.css';

type ErrorMessageProps = {
    className?: string;
    noIndent?: boolean;
    children: ReactNode | ErrorList;
    level?: 'error' | 'warning';
};

const ErrorMessage = ({
    className,
    children = [],
    noIndent = false,
    level = 'error',
}: ErrorMessageProps) => {
    const childrenArray = filterEmptyRecursive(Children.toArray(children));

    if (childrenArray.length === 0) {
        return null;
    }

    const iconStyles = classNames(
        styles.Icon,
        level === 'warning' && styles.Icon_warning
    );
    const errorMessageStyles = classNames(
        styles.Error,
        level === 'warning' && styles.Error_warning
    );

    const renderChild = (child: ReactNode, index: number): ReactNode => {
        if (Array.isArray(child)) {
            return child.map(renderChild);
        }

        return (
            <Row key={index} vertical="middle">
                <span className={iconStyles}>!</span>
                <Paragraph lineHeight="small" className={errorMessageStyles}>
                    {child}
                </Paragraph>
            </Row>
        );
    };

    return (
        <div
            className={classNames(styles.Root, className, {
                [styles.noIndent]: noIndent,
            })}
        >
            <Stack space="small">{childrenArray.map(renderChild)}</Stack>
        </div>
    );
};

export default ErrorMessage;
